<template lang="pug">
.delivery-order-container(:class="{ 'is-declined': delivery.status === 'declined' }")
  .list-items.form
    .item-delivery.capitalize.delivery-order-name-cell
      span.delivery-order-id.pointer(@click="goToDelivery") {{ delivery.delivery }}
      span.tag(v-if="delivery.type") {{ delivery.type }}
    .item-delivery.capitalize {{ text.states[delivery.status] }}
    .item-delivery {{ delivery.conveyor || '-' }}
    .item-delivery.delivery-tracking-cell
      span {{ delivery.tracking || '-' }}
      TrackDeliveryButton(:tracking="delivery.tracking" :conveyor="delivery.conveyor")
    .item-delivery {{ dateTime(delivery.createdAt) }}
    shExpandButton.line(@click.native.stop="show = !show" :expand="show")

  transition(name="slide-fade")
    div(v-if="show")
      .input-container
        input.input(v-model="delivery.nameRecipient" autocomplete="ño" disabled required)
        label.label(:class="{ show: delivery.nameRecipient }") Name Recipient

      shInputList(:dataForm="delivery" :dataOriginal="delivery" title="Phone Recipient" property="phonesRecipient" pattern="[0-9]{10}" :fillData="true" :required="1")

      .input-container
        textarea.input(v-model="delivery.addressRecipient" autocomplete="ño" rows="3" disabled required)
        label.label(:class="{ show: delivery.addressRecipient }") Address

      h3(v-if="delivery.observations && delivery.observations.length") Observations
      .observations-container
        .observation(v-for="(observation, index) in delivery.observations" :key="observation.createdAt")
          .observation-observation {{ index + 1 }}. {{ observation.observation }}
          div {{ dateTime(observation.createdAt) }}
          shNameUser(:dni="observation.createdBy")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import shExpandButton from '@/components/elements/ExpandButton'
import shNameUser from '@/components/elements/NameUser'
import shInputList from '@/components/elements/InputList'
import TrackDeliveryButton from '@/components/elements/delivery/TrackDeliveryButton.vue'
import router from '@my/router'

export default {
  name: 'Delivery',

  components: { shExpandButton, shNameUser, shInputList, TrackDeliveryButton },

  mixins: [mFilters, mForm],

  props: {
    delivery: Object,
    text: Object,
    conveyors: Array
  },

  mounted () {
    this.tracking.conveyor = this.delivery.conveyor
    this.tracking.tracking = this.delivery.tracking
  },

  data () {
    return {
      show: false,
      observations: [],
      observation: '',
      tracking: {
        conveyor: '',
        tracking: ''
      }
    }
  },

  methods: {
    goToDelivery () {
      if (!this.delivery || !this.delivery.delivery) return
      router.goToDeliveries({ delivery: this.delivery.delivery })
    }
  }
}
</script>

<style lang="stylus">
.delivery-order-container
  border-bottom 1px solid var(--color-border-items)
  border-radius 0

  .list-items
    border-radius 0

.delivery-order-container.is-declined
  color #9a9a9a

  .list-items
    background-color rgba(0, 0, 0, .04)

  .tag
    opacity .55
    filter grayscale(1)

.delivery-order-name-cell
  display flex
  flex-wrap wrap
  align-items baseline
  column-gap 0.35em

.delivery-order-id
  text-decoration underline
  text-underline-offset 0.12em

.delivery-tracking-cell
  display inline-flex
  flex-wrap wrap
  align-items center
  gap .35rem
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Delivery.vue